import type * as React from 'react';

import { Description, FieldGroup, Switch } from '@gitbook/spine-react';

import type { PageLayoutOptionsProps } from './types';

/**
 * Options to configure content on a page.
 * Through this, we can toggle page title & description visibility and also
 * change the width of the blocks.
 */
export function PageOptionsContent(props: PageLayoutOptionsProps): React.ReactElement {
    const { pageOptions, setPageOptionsUpdate } = props;
    return (
        <div className="flex flex-1 flex-col gap-2">
            <FieldGroup orientation="horizontal">
                <Description>Page title</Description>
                <Switch
                    value={!!pageOptions.layoutOptions.title}
                    onValueChange={(value) =>
                        setPageOptionsUpdate({
                            layoutOptions: {
                                ...pageOptions.layoutOptions,
                                title: value,
                            },
                        })
                    }
                />
            </FieldGroup>
            <FieldGroup orientation="horizontal">
                <Description>Page description</Description>
                <Switch
                    value={!!pageOptions.layoutOptions.description}
                    onValueChange={(value) =>
                        setPageOptionsUpdate({
                            layoutOptions: {
                                ...pageOptions.layoutOptions,
                                description: value,
                            },
                        })
                    }
                />
            </FieldGroup>
        </div>
    );
}
